module.exports = __webpack_public_path__ + "img/title-1.83a2f28e.png";